// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@awc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { rfqQuoteDetailsMessagesStyles } from "@awc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import { hideElementOnPrint, mergeWithCss } from "@awc/XDL/Utilities";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

rfqQuoteDetailsMessagesStyles.mainWrapper = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.wrapper, {
        css: css`
            flex-direction: column;
        `,
    }),
};

rfqQuoteDetailsMessagesStyles.messageTextArea = {
    css: css`
        min-width: 100%;
        max-width: 100%;
        min-height: 50px;
        resize: vertical;
    `,
    cssOverrides: {
        formField: css`
            margin-bottom: 12px;
            ${hideElementOnPrint}
        `,
    },
};

rfqQuoteDetailsMessagesStyles.sendButton = {
    css: css`
        ${hideElementOnPrint}
    `,
};

rfqQuoteDetailsMessagesStyles.mainWrapperNoMessages = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.wrapper, {
        css: css`
            flex-direction: column;
            ${hideElementOnPrint}
        `,
    }),
};

rfqQuoteDetailsMessagesStyles.messagesContainer = {
    gap: 0,
    css: css`
        ${GridOffset} {
            margin-top: 12px;
        }
        ${GridItemStyle} {
            margin: 0 0 8px 8px;
            padding: 8px;
            border-top: 1px solid ${getColor("common.ui2")};
            position: relative;
            background: ${getColor("common.ui2")};
            border-radius: 0px 6px 6px 6px;
            &:after {
                border-width: 0px 10px 10px 0;
                border-color: transparent ${getColor("common.ui2")} transparent transparent;
                top: -1px;
                left: -9px;
                position: absolute;
                content: "";
                width: 0;
                height: 0;
                border-style: solid;
            }
            &.current-user-message {
                border-radius: 6px 0px 6px 6px;
                &:after {
                    border-width: 0px 0 10px 10px;
                    border-color: transparent transparent transparent ${getColor("common.ui2")};
                    right: -9px;
                    left: unset;
                }
            }
        }
    `,
};

rfqQuoteDetailsMessagesStyles.userNameText = {
    weight: "bold",
    size: 12,
    css: css`
        @media print {
            margin-right: 10px;
        }
    `,
};

rfqQuoteDetailsMessagesStyles.messageDateText = {
    size: 12,
};

rfqQuoteDetailsMessagesStyles.messageBodyText = {
    size: 12,
};

rfqQuoteDetailsMessagesStyles.titleText = {
    variant: "h5",
    ...{ as: "h2" },
};
